/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import * as testing from './testing/dom_test_component_renderer';

export declare namespace __platform_browser_dynamic_private_types__ {
  export type DOMTestComponentRenderer = testing.DOMTestComponentRenderer;
  export var DOMTestComponentRenderer: typeof testing.DOMTestComponentRenderer;
}

export var __platform_browser_dynamic_private__ = {
  DOMTestComponentRenderer: testing.DOMTestComponentRenderer
};

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
